import {
  Button,
  ConfigProvider,
  Divider,
  Modal,
  Skeleton,
  Table,
  Tooltip,
  Card,
  Tabs,
} from "antd";
import { resetCurrentWorkspace } from "app-redux/actions/licensingAccounts.actions";
import { AppState } from "app-redux/reducers";
import { getCurrentUser } from "app-redux/selectors/accounts.selector";
import { getCurrentOrg } from "app-redux/selectors/orgs.selector";
import { getDefaultWorkspace } from "app-redux/selectors/licensingAccounts.selector";
import { iff } from "core/iff";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { connect, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import { notification, Spin } from "syngenta-digital-cropwise-react-ui-kit";
import PeopleOutline from "assets/icons/people_outline.svg";
import Pending from "assets/icons/pending.svg";
import {
  getCurrentSelectedPage,
  getDeepActionCBUrl,
  getDeepActionUrl,
  getResourceAttachmentIds,
  isPermissionAccess,
  isUK,
  checkOrgOwnership,
  isUsingRBAC,
  translationWrapper,
  checkUserPermissionWithOrgsOwnerShip,
  redirectToInviteMemberMFeOrDeepAction,
  redirectToEditMemberMFeOrDeepAction,
} from "../../utils/common-methods";
import "./styles.less";
import { WorkspaceDetailsHeader } from "components/Workspace/WorkspaceDetailsHeader/WorkspaceDetailsHeader";
import {
  getOrgsAndProperties,
  getWorkspaceAccounts,
  removeMemberAccess,
} from "services/MemberService";
import { find, get, isEmpty } from "lodash";
import { getOrgPropertyRBACActions, verifyRBACPermission } from "services/rbac";
import NoAccessPage from "components/NoAccessPage";
import No_User_Found from "../../assets/images/No_User_Found.png";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { RBAC_ACTIONS } from "services/rbacActions";
import { useMediaQuery } from "react-responsive";
import { PendingMembers } from "./pending-members";
import { OrganizationDTO } from "core/orgs/models";
const NO_OF_PROPERTIES_PER_PAGE = 10;

export interface RoleEditDTO {
  operation: RoleOperation;
  roles: RoleAssociationRequestDTO[];
}

export interface RoleAssociationRequestDTO {
  role_context: string;
  role_id: string;
  property_id?: string;
  org_id?: string;
  workspace_id?: string;
  app_id?: string;
}

export type RoleOperation = "ADD" | "REMOVE" | string;

const getMemberRolesByCurrentWorkspace = (
  member: any,
  role: any,
  currentWorkspaceId: string
) => {
  if (!member.roles) {
    member.roles = [];
  }
  const resourceAttachmentIds: any = role.resource_attachment
    ? getResourceAttachmentIds(role.resource_attachment)
    : {};
  if (
    resourceAttachmentIds?.workspace_id &&
    resourceAttachmentIds.workspace_id === currentWorkspaceId
  ) {
    member.roles?.push(role);
  }
};

export const processMemberAndRoles = (
  members: any,
  roles: any,
  currentWorkspaceId: string
) => {
  roles.forEach((role: any) => {
    const member: any = find(members.content, { id: role.account_id });
    getMemberRolesByCurrentWorkspace(member, role, currentWorkspaceId);
  });
  return members;
};

export const customizeRenderEmpty = (props: any) => (
  <div className="empty-data-container" style={{ textAlign: "center" }}>
    <img src={No_User_Found} alt={props.t("No member Found")} />
    <p className="empty-data-title">{props.t(props.title)}</p>
    <p className="empty-data-subtitle">{props.t(props.subtitle)}</p>
  </div>
);

const PreviousPage = (props:any) => {
  const { t } = useTranslation();
  // eslint-disable-next-line
  return <a>{t('Previous')}</a>
}

const NextPage = (props:any) => {
  const { t } = useTranslation();
  // eslint-disable-next-line
  return <a>{t('Next')}</a>
}

export function itemRender(current:any, type: any, originalElement: any) {
  if(type === 'prev'){
    return <PreviousPage />
  } else if(type === 'next'){
    return <NextPage />
  } else {
    return null;
  }
}

export const getTotalRecordsForPagination = (data:any, isFirst: boolean, isLast: boolean, paginationLimit: number, currentPage: number) => {
  let total = data?.length;
  if((isFirst === true && isLast === false)) {
    total = paginationLimit + 1;
  } else if(isFirst === false && isLast === false){
    total = (paginationLimit * currentPage) + 1;
  } else if(isLast === true && isFirst === false){
    total = (paginationLimit * currentPage) - 1;
  }
  return total;
}

export const WorkspaceMemberContainer = (props: any) => {
  const { currentUser, currentOrg, orgs, isLoadingOrgs } = props;
  const currentOrgId = get(currentOrg, "id", undefined);
  const [productsData, setProductsData] = useState([]);
  const [hasLoadedData, setHasLoadedData] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const currentWorkspaceId: string = props.accountId;
  const [rbacPermissions, setRbacPermissions] = useState([]);
  const [isAccessToMemberView, setIsAccessToMemberView] = useState<boolean>(false);
  const [canEditMember, setCanEditMember] = useState<boolean>(false);
  const [showRemoveMemberDialog, setRemoveMemberDialog] = useState(null);
  const [memberDataBackup, setMemberDataBackup] = useState<any>([]);
  const [membersDataPageable, setMembersDataPageable] = useState<any>([]);
  const [checkedList, setCheckedList] = useState<any>([]);
  const [pageable, setPageable] =  useState({ first: true, last: false, paginationLimit: 10, currentPage: 1});
  const [checkedListMember, setCheckedListMember] = useState<any>([]);
  const { t } = translationWrapper(useTranslation());
  const { t: translate } = translationWrapper(useTranslation(), false);
  const [lazyLoadedCount, setLazyLoadedCount] = useState({
    searchResult: NO_OF_PROPERTIES_PER_PAGE,
    result: NO_OF_PROPERTIES_PER_PAGE,
  });

  const filterByTerm = (searchInput: any) => {
    const showDataFrom =
      checkedList.length > 0 ? checkedListMember : memberDataBackup;
    return showDataFrom.filter((member: any) =>
      member.name.toLowerCase().includes(searchInput.toLowerCase())
    );
  };

  async function getAccounts() {
    const orgsInCurrentWorkspace = orgs?.flatMap((org: any) =>
      org.workspace_id === currentWorkspaceId ? [org.id] : []
    );
    if (!isEmpty(currentWorkspaceId) && !isEmpty(orgsInCurrentWorkspace)) {
      const workspaceAccountsResponse: any = await getWorkspaceAccounts(
        currentWorkspaceId,
        orgsInCurrentWorkspace,
        { size: 999 }
      );
      const { status, roles, members } = workspaceAccountsResponse;
      if (status) {
        let processedData = roles.length
          ? processMemberAndRoles(members, roles, currentWorkspaceId)
          : members;
        setProductsData(processedData.content);
      }
      setHasLoadedData(true);
    }
  }

  useEffect(() => {
    if (!props.workspaceLoading && !isLoadingOrgs) {
      getRBACPermissions();
    }
  }, [props.workspaceLoading, isLoadingOrgs, currentOrgId]);

  const checkUserPermissionsForMembers = async (permission: any) => {
    const { read, readANdWrite } = permission;
    if (read) {
      setIsAccessToMemberView(true);
      await getAccounts();
    }
    if (readANdWrite) {
      setCanEditMember(true);
    }
  };

  const updateRbacPermissions = async (allowed_operations: any) => {
    if (currentOrgId) {
      if (checkUserPermissionWithOrgsOwnerShip()) {
        const permission = {
          read: checkOrgOwnership(
            currentUser?.authorities,
            ["READ"],
            currentOrgId
          ),
          readANdWrite: checkOrgOwnership(
            currentUser?.authorities,
            ["READ", "WRITE"],
            currentOrgId
          ),
        };
        await checkUserPermissionsForMembers(permission);
      } else {
        const permission = {
          read: isPermissionAccess(
            allowed_operations,
            RBAC_ACTIONS.member.read
          ),
          readANdWrite: isPermissionAccess(
            allowed_operations,
            RBAC_ACTIONS.member.write
          ),
        };
        await checkUserPermissionsForMembers(permission);
      }
      setHasLoadedData(true);
    }
  };

  const getRBACPermissions = async () => {
    let defaultRbacPermissionsPayload = [
      {
        action: RBAC_ACTIONS.member.new,
        resource: `crn:workspace:${currentWorkspaceId}`,
      },
      {
        action: RBAC_ACTIONS.member.write,
        resource: `crn:workspace:${currentWorkspaceId}`,
      },
      {
        action: RBAC_ACTIONS.member.read,
        resource: `crn:workspace:${currentWorkspaceId}`,
      },
    ];
    const orgPropertyData = await getOrgsAndProperties(currentWorkspaceId);
    const rbacPermissionsPayload = getOrgPropertyRBACActions({
      ...{ currentWorkspaceId },
      ...orgPropertyData,
    });
    rbacPermissionsPayload.operations =
      rbacPermissionsPayload.operations.concat(defaultRbacPermissionsPayload);
    const {
      data: { allowed_operations = [] },
    }: any = await verifyRBACPermission(rbacPermissionsPayload);
    setRbacPermissions(allowed_operations);
    updateRbacPermissions(allowed_operations);
  };

  const isHeaderButtonActionsDisabled = () => {
    if (checkUserPermissionWithOrgsOwnerShip()) {
      return !isAccessToMemberView;
    } else {
      return !(
        isPermissionAccess(rbacPermissions, RBAC_ACTIONS.member.new) &&
        props.isInviteMembersEnabledOnFront
      );
    }
  };

  const getRBACUpdatePayload = (roles: any) => {
    const rolePayload: any = [];
    roles.forEach((role: any) => {
      rolePayload.push({
        role_context: role.context,
        role_id: role.role_id,
        ...getResourceAttachmentIds(role.resource_attachment),
      });
    });
    return rolePayload;
  };

  const removeMember = async (
    record: any,
    loadingCB: Function,
    successCB: Function
  ) => {
    loadingCB(true);
    let rolesToBeEdited: RoleEditDTO[] = [];
    const payload = { updates: rolesToBeEdited };
    if (record.roles && record.roles.length) {
      rolesToBeEdited.push({
        operation: "REMOVE",
        roles: getRBACUpdatePayload(record.roles),
      });
    }

    const removeMemberresposne = await removeMemberAccess(record.id, payload);
    if (removeMemberresposne.status) {
      getAccounts();
      successCB(false);
      successHandler(
        t("info.the_member_was_removed"),
        t(
          "info.the_user_doesnt_have_access_to_your_farms_and_organizations_anymore"
        )
      );
    } else {
      errorHandler(
        t("info.remove_member_failed"),
        t("info.the_remove_member_failed_try_again")
      );
      successCB(false);
    }
    loadingCB(false);
  };

  const successHandler = (message: string, description: string) => {
    notification.success({
      message,
      description,
      placement: "topRight",
      className: "member-delete-success-notification",
    });
  };

  const editMemberDA = (workspaceID: string, memberID: string) => {
    redirectToEditMemberMFeOrDeepAction(workspaceID, memberID);
  };
  const errorHandler = (message: string, description: string) => {
    notification.error({
      message,
      description,
      placement: "topRight",
    });
  };
  const handleEditMember = (workspaceID: string, memberID: string) => {
    if (canEditMember && props.isInviteMembersEnabledOnFront) {
      editMemberDA(workspaceID, memberID);
    }
  };
  const columns: any = [
    {
      title: t("title.member_name"),
      sorter: (a: any, b: any) => a.name.localeCompare(b.name),
      dataIndex: "name",
      key: "name",
      render: (text: string) => text,
    },
    {
      title: t("global.label.mail"),
      sorter: (a: any, b: any) => a.email.localeCompare(b.email),
      dataIndex: "email",
      key: "email",
      render: (text: string) => (
        <div
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          {text}
        </div>
      ),
    },
    {
      title: t("title.role"),
      dataIndex: "roles",
      key: "roles",
      render: (roles: any) => {
        if (roles && roles.length >= 1) {
          return (
            <Tooltip
              title={iff(
                roles.length === 1,
                <>{translate(roles[0].name)}</>,
                roles.map((role: any, index: any) => (
                  <>
                    {translate(role.name)}
                    <span
                      style={{
                        display: iff(index === roles.length - 1, "none"),
                      }}
                    >
                      ,{" "}
                    </span>
                  </>
                ))
              )}
            >
              <span>
                {iff(
                  roles.length > 1,
                  <div style={{ display: "flex" }}>
                    {`${roles[0].name},`}
                    <div className="memberRolesBiggerThanOne">
                      {roles.length - 1}+
                    </div>
                  </div>,
                  <>{translate(roles[0].name)}</>
                )}
              </span>
            </Tooltip>
          );
        }
      },
    },
    {
      title: t("title.actions"),
      key: "actions",
      dataIndex: "actions",
      fixed: "right",
      render: (_text: string, record: any) => (
        <div className="member-action-container">
          <Tooltip title={t("tooltip.edit_member")}>
            <div
              className={
                canEditMember
                  ? "member-action-details"
                  : "action-disabled-block"
              }
              onClick={() => handleEditMember(currentWorkspaceId, record.id)}
            >
              {t("global.button.edit")}
            </div>
          </Tooltip>
          <Divider
            type="vertical"
            style={{ top: "0.2em", height: "1.3em" }}
          />
          <Tooltip title={!record?.roles?.length ? t("tooltip.no_roles") : t("tooltip.remove_member")}>
            <Button
              disabled={!record?.roles?.length}
              danger
              type="text"
              className="member-action-remove"
              onClick={() => {
                setRemoveMemberDialog(record);
              }}
            >
              {t("button.remove")}
            </Button>
          </Tooltip>
        </div>
      ),
    },
  ];

  const inviteUserDA = () => {
    redirectToInviteMemberMFeOrDeepAction(props.accountId)
  };

  const handleMemberSearch = (searchInput: any) => {
    setSearchTerm(searchInput);
    setMembersDataPageable(filterByTerm(searchInput));
  };

  const getTableSourceData = () => {
    setMembersDataPageable(productsData);
    setMemberDataBackup(productsData);
  };

  const handleFilterChange = (checkedListData: []) => {
    if (checkedListData.length > 0) {
      setCheckedList(checkedListData);
      const addressesList = checkedListData.map((item: any) => item.id);
      const filteredMembers = [];
      for (const member of memberDataBackup) {
        const userRolesAccessData = member.authorities.map((r: any) => r.id);
        const haveAccess = userRolesAccessData.some((r: any) =>
          addressesList.includes(r)
        );
        if (haveAccess) {
          filteredMembers.push(member);
        }
      }
      setMembersDataPageable(filteredMembers);
      setCheckedListMember(filteredMembers);
    } else {
      setMembersDataPageable(memberDataBackup);
      setCheckedList([]);
    }
  };

  const isMobile = useMediaQuery({ query: "(max-width: 719px)" });
  const getEmptyMsgComponent = () => {
    const title =
      productsData.length === 0
        ? "global.info.no_members_yet"
        : "global.info.no_members_found";
    const subtitle = `global.info.${
      isUK() ? "invite_subtitle_digital" : "invite_subtitle_cropwise"
    }`;
    const subTitleText = productsData.length === 0 ? subtitle : "";
    return (
      <>{customizeRenderEmpty({ t, title: title, subtitle: subTitleText })}</>
    );
  };

  useEffect(() => {
    if (productsData) {
      getTableSourceData();
    }
  }, [productsData, lazyLoadedCount]);

  useEffect(() => {
    if (searchTerm) {
      setMembersDataPageable(filterByTerm(searchTerm));
    }
  }, [checkedList, lazyLoadedCount]);

  const getDataForMobile = () => {
    return (
      <Tabs>
        <Tabs.TabPane
          key="registered"
          tab={
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <img
                src={PeopleOutline}
                style={{ marginRight: 6 }}
              />
              {t("Registered")}
            </div>
          }
        >
          {
            membersDataPageable.length === 0 ? (
              <>
                { 
                  getEmptyMsgComponent()
                }
              </>
            ) : (
              membersDataPageable.map((member: any, key: any) => {
                return (
                  <>
                    <Card
                      key={key}
                      title={<b>{member.name}</b>}
                      className="memberCardContainer"
                      extra={
                        <div className="member-action-container">
                          <div
                            className={
                              canEditMember
                                ? "member-action-details memberActionEditButton"
                                : "action-disabled-block memberActionEditButton"
                            }
                            onClick={() =>
                              handleEditMember(currentWorkspaceId, member.id)
                            }
                          >
                            {t("global.button.edit")}
                          </div>
                          <div>
                            <Button
                              disabled={!member?.roles?.length}
                              danger
                              type="text"
                              className="member-action-remove"
                              onClick={() => {
                                setRemoveMemberDialog(member);
                              }}
                            >
                              {t("button.remove")}
                            </Button>
                          </div>
                        </div>
                      }
                    >
                      <div>
                        <div className="memberTableData">
                          <span>
                            <b>{t("global.label.mail")}</b>
                          </span>
                          <span>
                            <b>• </b>
                          </span>
                          <span>{member.email}</span>
                        </div>
                        <div className="memberTableData">
                          <span>
                            <b>{t("title.role")}</b>
                          </span>
                          <span>
                            <b>• </b>
                          </span>
                          <span>{member.roles?.map((role: any) => translate(role.name))?.join(', ')}</span>
                        </div>
                      </div>
                    </Card>
                  </>
                );
              }))
          }
        </Tabs.TabPane>
        <Tabs.TabPane
          key="pending"
          tab={
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <img
                src={Pending}
                style={{ marginRight: 6 }}
              />
              {t("Pending")}
            </div>
          }
        >
          <PendingMembers selectedOrgs={checkedList.map((org: OrganizationDTO) => org.id)}/>
        </Tabs.TabPane>
      </Tabs>
    )
  };

  const changeTable = (pagination: any) => {
    setPageable({...pageable, paginationLimit: pagination.pageSize})
  }

  return (
    <div className="member-page-spinging-component" data-testid="member-page-spinging-component">
      <Spin spinning={!hasLoadedData} tip="Loading...">
        <div
          data-testid="member-page-container-testid"
          className="member-page-container product-page-cont"
          id="member-page-container"
        >
          <div className="products-page-content">
            <WorkspaceDetailsHeader
              actionButton={{
                disabled: isHeaderButtonActionsDisabled(),
                click: inviteUserDA,
                title: "button.invite_user",
              }}
              title={`global.title.${getCurrentSelectedPage()}`}
              setSearchTerm={handleMemberSearch}
              handleFilterChange={handleFilterChange}
              t={t}
              currentWorkspaceId={currentWorkspaceId}
              resetCurrentWorkspace={props.resetCurrentWorkspace}
            />
            {iff(
              isAccessToMemberView,
              <div className="products-page-table">
                {!hasLoadedData ? (
                  <Skeleton loading={!hasLoadedData} active={true} />
                ) : (
                  <div className="member-page-tablemain-div">
                    {isMobile ? (
                      getDataForMobile()
                    ) : (
                      <ConfigProvider
                        renderEmpty={() => getEmptyMsgComponent}
                      >
                        <Tabs>
                          <Tabs.TabPane
                            key="registered"
                            tab={
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <img
                                  src={PeopleOutline}
                                  style={{ marginRight: 6 }}
                                />
                                {t("Registered")}
                              </div>
                            }
                          >
                            <Table
                              rowKey={(record: any) => record?.id ?? ""}
                              columns={columns}
                              dataSource={membersDataPageable}
                              onChange={changeTable}
                              pagination={{
                                pageSize: pageable.paginationLimit,
                                showSizeChanger: true,
                                }}
                            />
                          </Tabs.TabPane>
                          <Tabs.TabPane
                            key="pending"
                            tab={
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <img
                                  src={Pending}
                                  style={{ marginRight: 6 }}
                                />
                                {t("Pending")}
                              </div>
                            }
                          >
                            <PendingMembers selectedOrgs={checkedList.map((org: OrganizationDTO) => org.id)}/>
                          </Tabs.TabPane>
                        </Tabs>
                      </ConfigProvider>
                    )}
                  </div>
                )}
              </div>,
              hasLoadedData ? (
                <NoAccessPage
                  title={"title.you_dont_have_access_to_view_the_member_list"}
                  t={t}
                  message={
                    "info.to_access_please_ask_a_superior_to_change_your_role_or_edit_permissions"
                  }
                ></NoAccessPage>
              ) : (
                <Skeleton loading={true} active={true} />
              )
            )}
          </div>
        </div>
        {showRemoveMemberDialog && (
          <WarningModal
            removeMember={removeMember}
            record={showRemoveMemberDialog}
            showRemoveMemberDialog={showRemoveMemberDialog}
            setRemoveMemberDialog={setRemoveMemberDialog}
            t={t}
            title="info.do_you_want_to_remove_this_member"
            content="info.the_user_will_not_have"
          />
        )}
      </Spin>
    </div>
  );
};

export const WarningModal = (props: any) => {
  const { setRemoveMemberDialog, removeMember, title, content, record } = props;
  const [loading, setIsLoading] = useState(false);

  return (
    <>
      <Modal
        visible={true}
        okButtonProps={{ danger: true }}
        footer={[
          <Button
            key="back"
            onClick={() => {
              setRemoveMemberDialog(null);
            }}
          >
            {props.t("global.button.cancel")}
          </Button>,
          <Button
            danger
            key="submit"
            type="primary"
            loading={loading}
            onClick={() => {
              removeMember(record, setIsLoading, setRemoveMemberDialog);
            }}
          >
            {props.t("button.remove")}
          </Button>,
        ]}
        className="remove-memeber-dialog"
        closable={false}
      >
        <div
          data-testid="remove-memeber-dialog-container-testid"
          className="remove-memeber-dialog-container"
        >
          <div className="title-container">
            <ExclamationCircleOutlined className="error-icon" />
            <span>{props.t(title)}</span>
          </div>
          <div className="removeMemberContentText">{props.t(content)}</div>
        </div>
      </Modal>
    </>
  );
};

const mapStateToProps = (state: AppState) => ({
  currentUser: getCurrentUser(state),
  orgs: get(state, "orgsState.orgs", []),
  isLoadingOrgs: get(state, "orgsState.isLoadingOrgs", true),
  accountId: getDefaultWorkspace(state),
  currentWorkspaceId: getDefaultWorkspace(state),
  workspaceLoading: get(state, "workspaces.loading", true),
  currentOrg: getCurrentOrg(state),
  isProtectorBannerVisible:
    !state.rollout.loading && state.rollout?.flags?.isProtectorBannerVisible,
  isInviteMembersEnabledOnFront:
    state.rollout?.flags?.isInviteMembersEnabledOnFront,
});

const mapDispatchToProps = (dispatch: any) => ({
  resetCurrentWorkspace: () => dispatch(resetCurrentWorkspace()),
});

export const MembersPage = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(WorkspaceMemberContainer)
);
